import 'babel-polyfill'
import Vue from 'vue'
import Router from './route/index'
import vuex from 'vuex'
Vue.use(vuex);
var store = new vuex.Store({//store对象
  state:{
    cityId:110100,
    cityName:'北京'
  }
})

var routeView=Vue.component('routeView',{template:'<router-view></router-view>'});

new Vue({
  el: '#app',
  store,
  router:Router,
  render: h => h(routeView)
})


// WEBPACK FOOTER //
// ./src/main.js